// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ba7a7969","453":"dbb54e5b","732":"1abf1f0c"}[chunkId] + ".chunk.js";
};